module.exports = __webpack_public_path__ + "img/logo-clube-do-assinante.5d9bc60d.png";